(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = createSchema

const schemata = require('schemata')
const validateIfPropertyEquals = require('@clocklimited/validity-validate-if-property-equals')
const showSchema = require('./show-schema')
const createTaxSchema = require('./tax-schema')
const paymentScheduleSchema = require('./payment-schedule-schema')
const required = require('@clocklimited/validity-required')

function createSchema () {

  return schemata(
    { _id:
      { type: String
      }
    , contractNo:
      { type: Number
      }
    , status:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , agents:
      { type: Array
      , validators:
        { all: [ required ]
        }
      }
    , artist:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , artistContacts:
      { type: Array
      }
    , promoterContacts:
      { type: Array
      }
    , signatoryContact:
      { type: String
      }
    , promoter:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , shows:
      { type: schemata.Array(showSchema)
      , validators:
        { all: [ required ]
        }
      }
    , paymentSchedule:
      { type: schemata.Array(paymentScheduleSchema)
      }
    , dealType:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , percentage:
      { type: String
      }
    , overallFee:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , overallFeeNotes:
      { type: String
      }
    , crossCollateralised:
      { type: Boolean
      }
    , tax:
      { type: createTaxSchema()
      , validators:
        { all: [ validateIfPropertyEquals('crossCollateralised', true, required) ]
        }
      , defaultValue: null
      }
    , taxNotes:
      { type: String
      }
    , balanceDue:
      { type: Number
      }
    , specialTaxCircumstances:
      { type: Boolean
      , defaultValue: false
      }
    //, attachments:
    //  { type: schemata.Array(showSchema)
    //    , validators:
    //      { all: [ required ]
    //      }
    //  }
    , productionNotes:
      { type: String
      }
    , travelRequirements:
      { type: String
      }
    , hotelRequirements:
      { type: String
      }
    , groundTransport:
      { type: String
      }
    , visaRequirements:
      { type: String
      }
    , incidentals:
      { type: String
      }
    , passes:
      { type: String
      }
    , additionalProvisions:
      { type: String
      }
    , contractingWith:
      { type: String
      }
    , forServicesOf:
      { type: Boolean
      , defaultValue: false
      }
    , confirmedDate:
      { type: Date
      }
    , generalProvisions:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , generalProvisionsChanged:
      { type: Boolean
      }
    , office:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    })
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/contract/schema-definition.js","/components/service/contract")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvc2VydmljZS9jb250cmFjdC9zY2hlbWEtZGVmaW5pdGlvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwiZmlsZSI6ImdlbmVyYXRlZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzQ29udGVudCI6WyJtb2R1bGUuZXhwb3J0cyA9IGNyZWF0ZVNjaGVtYVxuXG5jb25zdCBzY2hlbWF0YSA9IHJlcXVpcmUoJ3NjaGVtYXRhJylcbmNvbnN0IHZhbGlkYXRlSWZQcm9wZXJ0eUVxdWFscyA9IHJlcXVpcmUoJ0BjbG9ja2xpbWl0ZWQvdmFsaWRpdHktdmFsaWRhdGUtaWYtcHJvcGVydHktZXF1YWxzJylcbmNvbnN0IHNob3dTY2hlbWEgPSByZXF1aXJlKCcuL3Nob3ctc2NoZW1hJylcbmNvbnN0IGNyZWF0ZVRheFNjaGVtYSA9IHJlcXVpcmUoJy4vdGF4LXNjaGVtYScpXG5jb25zdCBwYXltZW50U2NoZWR1bGVTY2hlbWEgPSByZXF1aXJlKCcuL3BheW1lbnQtc2NoZWR1bGUtc2NoZW1hJylcbmNvbnN0IHJlcXVpcmVkID0gcmVxdWlyZSgnQGNsb2NrbGltaXRlZC92YWxpZGl0eS1yZXF1aXJlZCcpXG5cbmZ1bmN0aW9uIGNyZWF0ZVNjaGVtYSAoKSB7XG5cbiAgcmV0dXJuIHNjaGVtYXRhKFxuICAgIHsgX2lkOlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgIH1cbiAgICAsIGNvbnRyYWN0Tm86XG4gICAgICB7IHR5cGU6IE51bWJlclxuICAgICAgfVxuICAgICwgc3RhdHVzOlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgICwgdmFsaWRhdG9yczpcbiAgICAgICAgeyBhbGw6IFsgcmVxdWlyZWQgXVxuICAgICAgICB9XG4gICAgICB9XG4gICAgLCBhZ2VudHM6XG4gICAgICB7IHR5cGU6IEFycmF5XG4gICAgICAsIHZhbGlkYXRvcnM6XG4gICAgICAgIHsgYWxsOiBbIHJlcXVpcmVkIF1cbiAgICAgICAgfVxuICAgICAgfVxuICAgICwgYXJ0aXN0OlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgICwgdmFsaWRhdG9yczpcbiAgICAgICAgeyBhbGw6IFsgcmVxdWlyZWQgXVxuICAgICAgICB9XG4gICAgICB9XG4gICAgLCBhcnRpc3RDb250YWN0czpcbiAgICAgIHsgdHlwZTogQXJyYXlcbiAgICAgIH1cbiAgICAsIHByb21vdGVyQ29udGFjdHM6XG4gICAgICB7IHR5cGU6IEFycmF5XG4gICAgICB9XG4gICAgLCBzaWduYXRvcnlDb250YWN0OlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgIH1cbiAgICAsIHByb21vdGVyOlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgICwgdmFsaWRhdG9yczpcbiAgICAgICAgeyBhbGw6IFsgcmVxdWlyZWQgXVxuICAgICAgICB9XG4gICAgICB9XG4gICAgLCBzaG93czpcbiAgICAgIHsgdHlwZTogc2NoZW1hdGEuQXJyYXkoc2hvd1NjaGVtYSlcbiAgICAgICwgdmFsaWRhdG9yczpcbiAgICAgICAgeyBhbGw6IFsgcmVxdWlyZWQgXVxuICAgICAgICB9XG4gICAgICB9XG4gICAgLCBwYXltZW50U2NoZWR1bGU6XG4gICAgICB7IHR5cGU6IHNjaGVtYXRhLkFycmF5KHBheW1lbnRTY2hlZHVsZVNjaGVtYSlcbiAgICAgIH1cbiAgICAsIGRlYWxUeXBlOlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgICwgdmFsaWRhdG9yczpcbiAgICAgICAgeyBhbGw6IFsgcmVxdWlyZWQgXVxuICAgICAgICB9XG4gICAgICB9XG4gICAgLCBwZXJjZW50YWdlOlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgIH1cbiAgICAsIG92ZXJhbGxGZWU6XG4gICAgICB7IHR5cGU6IFN0cmluZ1xuICAgICAgLCB2YWxpZGF0b3JzOlxuICAgICAgICB7IGFsbDogWyByZXF1aXJlZCBdXG4gICAgICAgIH1cbiAgICAgIH1cbiAgICAsIG92ZXJhbGxGZWVOb3RlczpcbiAgICAgIHsgdHlwZTogU3RyaW5nXG4gICAgICB9XG4gICAgLCBjcm9zc0NvbGxhdGVyYWxpc2VkOlxuICAgICAgeyB0eXBlOiBCb29sZWFuXG4gICAgICB9XG4gICAgLCB0YXg6XG4gICAgICB7IHR5cGU6IGNyZWF0ZVRheFNjaGVtYSgpXG4gICAgICAsIHZhbGlkYXRvcnM6XG4gICAgICAgIHsgYWxsOiBbIHZhbGlkYXRlSWZQcm9wZXJ0eUVxdWFscygnY3Jvc3NDb2xsYXRlcmFsaXNlZCcsIHRydWUsIHJlcXVpcmVkKSBdXG4gICAgICAgIH1cbiAgICAgICwgZGVmYXVsdFZhbHVlOiBudWxsXG4gICAgICB9XG4gICAgLCB0YXhOb3RlczpcbiAgICAgIHsgdHlwZTogU3RyaW5nXG4gICAgICB9XG4gICAgLCBiYWxhbmNlRHVlOlxuICAgICAgeyB0eXBlOiBOdW1iZXJcbiAgICAgIH1cbiAgICAsIHNwZWNpYWxUYXhDaXJjdW1zdGFuY2VzOlxuICAgICAgeyB0eXBlOiBCb29sZWFuXG4gICAgICAsIGRlZmF1bHRWYWx1ZTogZmFsc2VcbiAgICAgIH1cbiAgICAvLywgYXR0YWNobWVudHM6XG4gICAgLy8gIHsgdHlwZTogc2NoZW1hdGEuQXJyYXkoc2hvd1NjaGVtYSlcbiAgICAvLyAgICAsIHZhbGlkYXRvcnM6XG4gICAgLy8gICAgICB7IGFsbDogWyByZXF1aXJlZCBdXG4gICAgLy8gICAgICB9XG4gICAgLy8gIH1cbiAgICAsIHByb2R1Y3Rpb25Ob3RlczpcbiAgICAgIHsgdHlwZTogU3RyaW5nXG4gICAgICB9XG4gICAgLCB0cmF2ZWxSZXF1aXJlbWVudHM6XG4gICAgICB7IHR5cGU6IFN0cmluZ1xuICAgICAgfVxuICAgICwgaG90ZWxSZXF1aXJlbWVudHM6XG4gICAgICB7IHR5cGU6IFN0cmluZ1xuICAgICAgfVxuICAgICwgZ3JvdW5kVHJhbnNwb3J0OlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgIH1cbiAgICAsIHZpc2FSZXF1aXJlbWVudHM6XG4gICAgICB7IHR5cGU6IFN0cmluZ1xuICAgICAgfVxuICAgICwgaW5jaWRlbnRhbHM6XG4gICAgICB7IHR5cGU6IFN0cmluZ1xuICAgICAgfVxuICAgICwgcGFzc2VzOlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgIH1cbiAgICAsIGFkZGl0aW9uYWxQcm92aXNpb25zOlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgIH1cbiAgICAsIGNvbnRyYWN0aW5nV2l0aDpcbiAgICAgIHsgdHlwZTogU3RyaW5nXG4gICAgICB9XG4gICAgLCBmb3JTZXJ2aWNlc09mOlxuICAgICAgeyB0eXBlOiBCb29sZWFuXG4gICAgICAsIGRlZmF1bHRWYWx1ZTogZmFsc2VcbiAgICAgIH1cbiAgICAsIGNvbmZpcm1lZERhdGU6XG4gICAgICB7IHR5cGU6IERhdGVcbiAgICAgIH1cbiAgICAsIGdlbmVyYWxQcm92aXNpb25zOlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgICwgdmFsaWRhdG9yczpcbiAgICAgICAgeyBhbGw6IFsgcmVxdWlyZWQgXVxuICAgICAgICB9XG4gICAgICB9XG4gICAgLCBnZW5lcmFsUHJvdmlzaW9uc0NoYW5nZWQ6XG4gICAgICB7IHR5cGU6IEJvb2xlYW5cbiAgICAgIH1cbiAgICAsIG9mZmljZTpcbiAgICAgIHsgdHlwZTogU3RyaW5nXG4gICAgICAsIHZhbGlkYXRvcnM6XG4gICAgICAgIHsgYWxsOiBbIHJlcXVpcmVkIF1cbiAgICAgICAgfVxuICAgICAgfVxuICAgIH0pXG59XG4iXX0=